import SpinnerWrapper, { SpinnerWrapperContext } from './SpinnerWrapper.Context';

export { SpinnerWrapperContext };

export default SpinnerWrapper;
